<div class="c-card c-content c-content--xxl u-wrapper" [ngStyle]="{'min-height': '200px'}">
	<form name="vm.form" class="c-form">
		<fieldset>
			<legend class="c-form__label">{{ 'Symptom_Check.Region_Question' | translate }}</legend>
			<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && travelRegion.invalid}">
				<label class="c-radio">
					<input type="radio" name="travelRegion" [(ngModel)]="vm.isEuropeRegion" [value]="false" #travelRegion="ngModel" (click)="vm.handleTravelResponse('yes')" required>
					<span id="travelEuropeRegion">{{ 'Common.Yes' | translate }}</span>
				</label>
			</div>
			<div class="c-form__group u-osb-md" [ngClass]="{'c-form__group--error': vm.submitted && travelRegion.invalid}">
				<label class="c-radio">
					<input type="radio" name="travelRegion" [(ngModel)]="vm.isEuropeRegion" [value]="true" #travelRegion="ngModel" (click)="vm.handleTravelResponse('no')" required>
					<span id="travelOutsideEuropeRegion">{{ 'Common.No' | translate }}</span>
				</label>
			</div>
		</fieldset>
	</form>
	<div [ngStyle]="!vm.isInitialized && {'min-height': '200px'}">
		<p class="c-text c-text--spaced u-osb-md" *ngIf="vm.isInitialized && !vm.isEuropeRegion">
			<span>{{ 'Symptom_Check.Regions.Intro' | translate }}</span>
			<a href="javascript:void(0)" class="u-no-wrap c-text--bold" *ngIf="vm.preVisit" (click)="vm.handleSubmit()">{{ 'Symptom_Check.Regions.PreVisitRegionSkip' | translate }}</a>
		</p>
		<div id="map" *ngIf="vm.isInitialized && !vm.isEuropeRegion"></div>
		<loader-overlay *ngIf="!vm.isInitialized || vm.isProcessing"></loader-overlay>
	</div>
	<div class="o-grid u-ost-md">
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
			<button id="backButton" class="c-button c-button--link c-button--fit c-button--lg" type="button" (click)="vm.handleBack()">{{ 'Common.Back' | translate }}</button>
		</div>
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
			<button id="submitButton" class="c-button c-button--s1 c-button--fit c-button--lg" type="button" (click)="vm.handleSubmit()">{{ 'Common.Next' | translate }}</button>
		</div>
	</div>
</div>
